import { GetReport } from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

export interface ReportParam {
  rmaNo: string;
  qcCount?: number;
}

const endPoint = 'inspection/report';

export const fetchReport = async (params: ReportParam): Promise<GetReport> => {
  const queryParams = new URLSearchParams();
  queryParams.append('rmaNo', params.rmaNo);

  if (params.qcCount) {
    queryParams.append('qcCount', params.qcCount.toString());
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
